import * as Types from '../types-api.generated';

import { BidFragment, UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiLiveAuctionVariables = Types.Exact<{
  currentUserPublicKey?: Types.InputMaybe<Types.Scalars['Address']>;
  nftFilter: Types.ApiNftInput;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiLiveAuction = { isLiveAuctionBidder: boolean | null, liveAuction: { currentBidAmount: number, endTime: string, recentBids: Array<{ amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }>, bids: { page: number, totalItems: number, totalPages: number, items: Array<{ amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }> }, firstBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } } | null };



export const ApiLiveAuctionDocument = /*#__PURE__*/ `
    query LiveAuction($currentUserPublicKey: Address, $nftFilter: NftInput!, $page: Int, $perPage: Int) {
  liveAuction(nft: $nftFilter, page: $page, perPage: $perPage) {
    currentBidAmount
    endTime
    recentBids {
      ...BidFragment
    }
    bids {
      items {
        ...BidFragment
      }
      page
      totalItems
      totalPages
    }
    firstBid {
      ...BidFragment
    }
  }
  isLiveAuctionBidder(accountAddress: $currentUserPublicKey, nft: $nftFilter)
}
    ${BidFragment}
${UserLightFragment}`;

export const useLiveAuction = <
      TData = ApiLiveAuction,
      TError = ClientError
    >(
      variables: ApiLiveAuctionVariables,
      options?: Omit<UseQueryOptions<ApiLiveAuction, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiLiveAuction, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiLiveAuction, TError, TData>(
      {
    queryKey: ['LiveAuction', variables],
    queryFn: apiFetcher<ApiLiveAuction, ApiLiveAuctionVariables>(ApiLiveAuctionDocument, variables),
    ...options
  }
    )};

useLiveAuction.getKey = (variables: ApiLiveAuctionVariables) => ['LiveAuction', variables];

export const useInfiniteLiveAuction = <
      TData = InfiniteData<ApiLiveAuction>,
      TError = ClientError
    >(
      variables: ApiLiveAuctionVariables,
      options: Omit<UseInfiniteQueryOptions<ApiLiveAuction, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiLiveAuction, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiLiveAuction, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['LiveAuction.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiLiveAuction, ApiLiveAuctionVariables>(ApiLiveAuctionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteLiveAuction.getKey = (variables: ApiLiveAuctionVariables) => ['LiveAuction.infinite', variables];


useLiveAuction.fetcher = (variables: ApiLiveAuctionVariables, options?: RequestInit['headers']) => apiFetcher<ApiLiveAuction, ApiLiveAuctionVariables>(ApiLiveAuctionDocument, variables, options);
